export default __webpack_public_path__ + "static/media/a1410b52bd489e2ae8beaa87709701e3.png";